// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"aeab719e","127":"d64f6bed","525":"da99d569","774":"2a3400ed"}[chunkId] + ".chunk.js";
};